// @flow

import React, { Component } from 'react';
import type { Node, ComponentType } from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import type { Theme } from '../../types';
import Wordpress from '../wordpress';

type Props = {
  children: Array<Node> | Node,
  store: Object,
  theme: Theme,
  Router: ComponentType<*>,
  onInit?: Function, // eslint-disable-line react/require-default-props
};

class Listo extends Component<Props> {
  componentDidMount() {
    const { onInit } = this.props;
    if (onInit) {
      onInit();
    }
  }

  render() {
    const {
      children, store, theme, Router,
    } = this.props;
    return (
      <ThemeProvider theme={() => theme}>
        <Provider store={store}>
          <Router>
            <Wordpress>{children}</Wordpress>
          </Router>
        </Provider>
      </ThemeProvider>
    );
  }
}

export default Listo;
